import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { ScrollArea } from '@/components/ui/scroll-area';

import { CreateSandboxForm } from './createSandboxForm';

interface CreateSandboxModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export const CreateSandboxModal = ({ open, onOpenChange }: CreateSandboxModalProps) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Create New Sandbox</DialogTitle>
        </DialogHeader>
        <DialogDescription className="sr-only">
          Create a new sandbox for the current game
        </DialogDescription>
        <ScrollArea className="max-h-[80vh]">
          <CreateSandboxForm
            close={(close) => {
              if (close) {
                onOpenChange(false);
              }
            }}
          />
        </ScrollArea>
      </DialogContent>
    </Dialog>
  );
};